import { render, staticRenderFns } from "./payWatch.vue?vue&type=template&id=1f66750a&scoped=true"
import script from "./payWatch.vue?vue&type=script&lang=js"
export * from "./payWatch.vue?vue&type=script&lang=js"
import style0 from "./payWatch.vue?vue&type=style&index=0&id=1f66750a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f66750a",
  null
  
)

export default component.exports